(() => {
  const SELECTORS = {
    root: '[data-scheduled-popup]',
    dialog: '[data-scheduled-popup-dialog]',
    close: '[data-scheduled-popup-close]',
  };

  const STORAGE_PREFIX = 'scheduled-popup-dismissed:';

  function initScheduledPopup() {
    const root = document.querySelector(SELECTORS.root);
    if (!root) return;

    const dialog = root.querySelector(SELECTORS.dialog);
    const closeTargets = root.querySelectorAll(SELECTORS.close);
    const popupKey = root.dataset.popupKey;

    if (!dialog) return;
    if (popupKey && localStorage.getItem(`${STORAGE_PREFIX}${popupKey}`) === '1') return;

    const previousActiveElement = document.activeElement;

    const closePopup = () => {
      root.classList.remove('is-active');
      root.setAttribute('hidden', 'hidden');
      document.body.classList.remove('scheduled-popup-open');

      if (popupKey) {
        localStorage.setItem(`${STORAGE_PREFIX}${popupKey}`, '1');
      }

      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(previousActiveElement);
      } else if (previousActiveElement && typeof previousActiveElement.focus === 'function') {
        previousActiveElement.focus();
      }

      document.removeEventListener('keydown', onKeyDown);
    };

    const onKeyDown = (event) => {
      if (event.code === 'Escape') {
        closePopup();
      }
    };

    closeTargets.forEach((element) => {
      element.addEventListener('click', closePopup);
    });

    root.removeAttribute('hidden');
    root.classList.add('is-active');
    document.body.classList.add('scheduled-popup-open');

    if (typeof trapFocus === 'function') {
      trapFocus(dialog, dialog);
    } else {
      dialog.focus();
    }

    document.addEventListener('keydown', onKeyDown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScheduledPopup);
  } else {
    initScheduledPopup();
  }
})();
